import React from 'react';
import PropTypes from 'prop-types';

import "./InfoTile.scss";

const kFormat = num => Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K' : Math.sign(num)*Math.abs(num)

const InfoTile = ({ count, title, secondaryTitle })=> {
  return (
    <div className="info-tile">
      <span className="info-tile__count">{kFormat(count)}</span>
      <span className="info-tile__title">{title}</span>
      <span className="info-tile__secondary-title">{secondaryTitle}</span>
    </div>
  );
};

InfoTile.propTypes = {
  count: PropTypes.number, 
  secondaryTitle: PropTypes.string, 
  title: PropTypes.string
};

InfoTile.defaultProps = {
  count: 0, 
  secondaryTitle: "", 
  title: ""
};

export default InfoTile;